const IgnoredKeys = Object.freeze(['marker', 'tooltip', 'onChangeListener']);

export { IgnoredKeys };
